"use strict";
/**
 * Created by Ning Jiang on 4/20/2016.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WinPresentationEvent = void 0;
class WinPresentationEvent {
}
WinPresentationEvent.WIN_PRESENTATIONS_STARTED = "winPresentationEvent_winPresentationsStarted";
WinPresentationEvent.ALL_PRESENTATIONS_COMPLETED = "winPresentationEvent_allPresentationsCompleted";
WinPresentationEvent.UPDATE_WIN_PRESENTATION_BET_WINS = "winPresentationEvent_updateWinPresentationBetWins";
WinPresentationEvent.WIN_PRESENTATION_STARTED = "winPresentationEvent_winPresentationStarted";
WinPresentationEvent.WIN_PRESENTATION_COMPLETED = "winPresentationEvent_winPresentationCompleted";
WinPresentationEvent.WIN_PRESENTATION_ABORTED = "winPresentationEvent_winPresentationAborted";
exports.WinPresentationEvent = WinPresentationEvent;
//# sourceMappingURL=WinPresentationEvent.js.map